export default {"src":"/_next/static/media/New_VF_Icon_RGB_RED.2fd3d38c.svg","height":416,"width":416};